import styled from 'styled-components';
import { Theme } from '../../pages/Styles/Theme';
import { Progress } from 'antd';

export const SidebarWrapper = styled.div`
  @media (max-width: 991px) {
    display: none;
  }
  width: ${props => (props.collapsed ? '60px' : '220px')};
  height: 100vh;
  background: ${({ theme }) => theme.settings.whiteColor};
  border-right: none;
  position: fixed;
  left: 0;
  top: 0;
  padding: 0px 0 12px 12px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  transition: width 0.3s ease;
  z-index: 1000;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-track {
    /* background: ${({ theme }) => theme.settings.bodyBg}; */
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    /* background: ${({ theme }) => theme.settings.borderColor}; */
    background: transparent;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    /* background: ${({ theme }) => theme.settings.cardBg}; */
    background: transparent;
  }
`;

export const SidebarHeader = styled.div`
  position: sticky;
  top: 0;
  background: ${({ theme }) => theme.settings.whiteColor};
  width: 100%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0px 0px 0px;
  margin-bottom: 20px;
  ${props => props.collapsed && 'position: relative; min-height: 36px;'}
`;

export const ThemeLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => (props.collapsed ? 'center' : 'flex-start')};
  flex-shrink: 0;
  ${props =>
    props.collapsed &&
    'position: absolute; inset: 0; z-index: 0; margin-top: 10px;'}
  img {
    height: ${props => (props.collapsed ? '18px' : '22px')};
    width: ${props => (props.collapsed ? 'auto' : 'auto')};
    max-width: ${props => (props.collapsed ? '32px' : 'none')};
    object-fit: contain;
    display: block;
    transition:
      height 0.2s ease,
      max-width 0.2s ease;
  }
`;

export const ToggleSwitchWrap = styled.div`
  opacity: ${props => (props.collapsed && !props.isHovered ? 0 : 1)};
  visibility: ${props =>
    props.collapsed && !props.isHovered ? 'hidden' : 'visible'};
  pointer-events: ${props =>
    props.collapsed && !props.isHovered ? 'none' : 'auto'};
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease;
  ${props =>
    props.collapsed &&
    `
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  `}
`;

export const ToggleSwitch = styled.div`
  cursor: pointer;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: ${props =>
    props.collapsed ? ({ theme }) => theme.settings.cardBg : 'transparent'};
  box-shadow: ${props =>
    props.collapsed ? '0 1px 2px rgba(0,0,0,0.06)' : 'none'};
  transition:
    transform 0.3s ease,
    background 0.2s ease,
    box-shadow 0.2s ease;
  &:hover {
    background: ${props =>
      props.collapsed ? ({ theme }) => theme.settings.cardBg : 'transparent'};
    box-shadow: ${props =>
      props.collapsed ? '0 2px 6px rgba(0,0,0,0.1)' : 'none'};
  }
  img {
    transition: transform 0.3s ease;
    transform: ${props =>
      props.collapsed ? 'rotate(0deg)' : 'rotate(180deg)'};
  }
`;

export const RightArrowIcon = styled.div`
  color: #6f7b8c;
  font-size: 12px;
`;

export const ProfileCard = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  background: ${({ theme }) => theme.settings.cardBg};
  border-radius: 10px;
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  @media only screen and (max-width: 991.99px) {
    border-radius: 0px;
    margin-bottom: 0px;
    border-bottom: 1px solid ${({ theme }) => theme.settings.borderColor};
  }
  &:hover {
    transform: scale(0.95);
  }
`;

export const ProfileAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ProfileInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ProfileName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.settings.primary};
  line-height: 1.4;
`;

export const ProfileRole = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.settings.textColor};
  line-height: 1.4;
`;

export const MenuWrapper = styled.div`
  flex: 1;
  margin-bottom: 20px;
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 12px;
  margin-bottom: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  background: ${props =>
    props.active ? Theme.settings.whiteColor : 'transparent'};
  border: 1px solid
    ${props => (props.active ? Theme.settings.borderColor : 'transparent')};

  color: ${props =>
    props.active ? Theme.settings.primary : Theme.settings.secondary};
  transition: all 0.3s ease;
  &:hover {
    transform: scale(0.95);
  }
`;

export const MenuIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
  img {
    width: 20px;
    height: 20px;
    filter: ${props =>
      props.active
        ? 'brightness(0) saturate(100%) invert(4%) sepia(71%) saturate(6294%) hue-rotate(240deg) brightness(98%) contrast(94%)'
        : 'brightness(0) saturate(100%) invert(30%) sepia(7%) saturate(1811%) hue-rotate(187deg) brightness(93%) contrast(88%)'};
  }
`;

export const MenuLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const MenuBadge = styled.span`
  background: ${({ theme }) => theme.settings.primary};
  color: ${({ theme }) => theme.settings.whiteColor};
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: 8px;
  line-height: 1.4;
`;

// New collapsed menu components
export const CollapsedMenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin: 0 auto 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  background: ${props => (props.active ? '#F4F6F9' : 'transparent')};
  /* &:hover {
    background: #f4f6f9;
  } */
`;

export const CollapsedMenuIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  img {
    width: 20px;
    height: 20px;
    filter: ${props =>
      props.active
        ? 'brightness(0) saturate(100%) invert(4%) sepia(71%) saturate(6294%) hue-rotate(240deg) brightness(98%) contrast(94%)'
        : 'brightness(0) saturate(100%) invert(30%) sepia(7%) saturate(1811%) hue-rotate(187deg) brightness(93%) contrast(88%)'};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const CollapsedBadge = styled.span`
  position: absolute;
  top: -2px;
  right: -2px;
  background: ${({ theme }) => theme.settings.primary};
  color: ${({ theme }) => theme.settings.whiteColor};
  font-size: 8px;
  font-weight: 600;
  padding: 1px 4px;
  border-radius: 8px;
  line-height: 1.2;
  min-width: 12px;
  text-align: center;
`;

export const ProfileCompletion = styled.div`
  background: ${({ theme }) => theme.settings.cardBg};
  border-radius: 12px;
  padding: 20px 16px;
  margin-bottom: 16px;
  text-align: center;
  position: relative;
  transition: all 0.3s ease;
  @media only screen and (max-width: 991.99px) {
    border-radius: 0px;
  }
  &:hover {
    transform: scale(0.95);
  }
`;
export const ProgressText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.settings.primary};
`;

export const CompletionTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.settings.primary};
  margin-bottom: 8px;
  line-height: 1.4;
  margin-top: 8px;
`;

export const CompletionSubtitle = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.settings.textColor};
  margin-bottom: 16px;
  line-height: 1.5;
`;

export const ProfileButton = styled.button`
  width: 100%;
  padding: 8px 16px;
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.settings.primary};
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background: ${({ theme }) => theme.settings.primary};
    color: ${({ theme }) => theme.settings.whiteColor};
    border-color: ${({ theme }) => theme.settings.primary};
  }
`;

export const HelpCenter = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  background: ${({ theme }) => theme.settings.cardBg};
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    transform: scale(0.95);
  }
`;

export const HelpIcon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
`;

export const HelpContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const HelpTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.settings.primary};
  line-height: 1.4;
`;

export const HelpSubtitle = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.settings.textColor};
  line-height: 1.4;
`;
export const ProgressSidebar = styled(Progress)`
  width: 100%;
  position: relative;
  .ant-progress-text {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 16px !important;
    font-weight: 600 !important;
    color: ${({ theme }) => theme.settings.primary} !important;
    line-height: 1.4 !important;
  }
`;

export const LogoutTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.settings.primary};
  line-height: 1.4;
`;

export const LogoutButton = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  background: ${({ theme }) => theme.settings.cardBg};
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 8px;
  &:hover {
    transform: scale(0.95);
  }
`;

export const LogoutIcon = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
`;

export const LogoutContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const BottomSection = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
`;

// ChatGPT-style Bottom Profile Menu
export const VersionWrapper = styled.div`
  padding: 0 12px 4px 12px;
`;

export const VersionDivider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.settings.borderColor};
  opacity: 0.4;
  margin-bottom: 8px;
`;

export const VersionText = styled.div`
  font-size: 10px;
  font-weight: 500;
  color: ${({ theme }) => theme.settings.textColor};
  opacity: 0.35;
  text-align: center;
  letter-spacing: 0.3px;
`;

export const BottomProfileWrapper = styled.div`
  margin-top: auto;
  position: relative;
`;

export const BottomProfileButton = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${props =>
    props.isOpen ? ({ theme }) => theme.settings.cardBg : 'transparent'};

  &:hover {
    background: ${({ theme }) => theme.settings.cardBg};
  }
`;

export const BottomProfileInfo = styled.div`
  flex: 1;
  min-width: 0;
  margin-left: 10px;
  display: flex;
  align-items: center;
`;

export const BottomProfileName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.settings.primary};
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BottomProfileRole = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.settings.textColor};
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProfileDropdownMenu = styled.div`
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  margin-bottom: 8px;
  background: ${({ theme }) => theme.settings.whiteColor};
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  overflow: hidden;
  z-index: 1001;
  opacity: ${props => (props.isOpen ? 1 : 0)};
  visibility: ${props => (props.isOpen ? 'visible' : 'hidden')};
  transform: ${props => (props.isOpen ? 'translateY(0)' : 'translateY(10px)')};
  transition: all 0.2s ease;
`;

export const ProfileDropdownItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.2s ease;
  color: ${({ theme }) => theme.settings.primary};
  font-size: 14px;
  font-weight: 500;

  &:hover {
    background: ${({ theme }) => theme.settings.cardBg};
  }

  img,
  svg {
    width: 18px;
    height: 18px;
    margin-right: 12px;
    filter: ${({ theme }) => theme.settings.imgFilterColor};
  }

  &.danger {
    color: #e65b5b;

    img,
    svg {
      filter: brightness(0) saturate(100%) invert(47%) sepia(74%)
        saturate(1143%) hue-rotate(322deg) brightness(93%) contrast(92%);
    }
  }
`;

export const ProfileDropdownDivider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.settings.borderColor};
  margin: 4px 0;
`;

export const CollapsedBottomProfile = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin: 0 auto 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    background: #f4f6f9;
  }
`;
